<div class="container">
    <BR><BR>
    <h1>Contact US</h1>

    <section id="contact-form" class="py-3">
		
			

			<form (submit)="onFormSubmit()" [formGroup]="contactForm">
				<div class="form-group row">
					<div class="col-lg-6">
						<label for="name">Name</label>
						<input type="name" formControlName="name" id="name">
					</div>

					<div class="col-lg-6">
						<label for="email">Email</label>
						<input type="email" formControlName="email" id="email">
					</div>
				</div>

				<div class="form-group">
					<label for="subject">Subject</label>
					<input type="text" formControlName="subject" id="subject">
				</div>
				<div class="form-group">
					<label for="message">Message</label>
					<textarea formControlName="message" id="message"></textarea>
				</div>
				<button type="submit" class="btn btn-warning" style="border-radius: 10px;">Submit</button>
			</form>
		
	</section>
</div>
